import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import gsap from "gsap";

const SafetySlider = ({ slides }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const swiperRef = useRef(null);

  const handlePrev = () => {
    if (swiperRef.current) swiperRef.current.swiper.slidePrev();
  };

  const handleNext = () => {
    if (swiperRef.current) swiperRef.current.swiper.slideNext();
  };

  const handleSlideChange = (swiper) => {
    setCurrentSlide(swiper.activeIndex);
    const activeSlide = swiper.slides[swiper.activeIndex];
    gsap.fromTo(
      activeSlide,
      { opacity: 0, y: 20 },
      { opacity: 1, y: 0, duration: 0.6, ease: "power2.out" }
    );
  };

  return (
    <div className="container safety-slider">
      <div className="row row-cols-1 row-cols-lg-3">
        {slides?.map((slide, index) => (
          <div className="col" key={index} onClick={()=>setCurrentSlide(index)} style={{cursor: "pointer"}}>
            <p className="auto-tabs fs-4">{slide.title}</p>
            <div
              className="progress"
              role="progressbar"
              style={{ height: "4px" }}
              aria-label="Basic example"
              aria-valuenow={(index === currentSlide ? 100 : 0)}
              aria-valuemin="0"
              aria-valuemax="100"
            >
              <div
                className="progress-bar"
                style={{
                  width: index === currentSlide ? "100%" : "0%",
                  height: "4px",
                }}
              ></div>
            </div>
          </div>
        ))}
      </div>

      <div className="row  mt-5 justify-content-between align-items-center">
        <div className="col col-12 col-lg-6 ">
          <Swiper
            ref={swiperRef}
            modules={[Autoplay, Navigation, Pagination]}
            spaceBetween={30}
            slidesPerView={1}
            autoplay={{ delay: 3000 }}
            onSlideChange={handleSlideChange}
            className="swiper-container"
          >
            {slides?.map((slide, index) => (
              <SwiperSlide key={index}>
                <p className="fs-6 mb-5">{slide.description}</p>
                <Link className="text-decoration-none d-block mb-5">
                  Find out about our products <i className="fa-regular fa-circle-right"></i>
                </Link>
                <img
                  src={slide.statsImage}
                  alt="Stats"
                  className="w-50"
                />
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="d-flex mt-4">
            <button
              className="btn btn-warning btn-lg rounded-0 me-2"
              onClick={handlePrev}
            >
              <i className="fa-solid fa-arrow-left"></i>
            </button>
            <button
              className="btn btn-warning btn-lg rounded-0"
              onClick={handleNext}
            >
              <i className="fa-solid fa-arrow-right"></i>
            </button>
          </div>
        </div>
        <div className="col d-flex main-image justify-content-end">
          <img
            src={slides[currentSlide]?.mainImage}
            alt="Slide Main"
            // className="w-100"
           
          />
        </div>
      </div>
    </div>
  );
};

export default SafetySlider;
